import { useTranslation } from '@rhino-project/core/i18n';
import { useEffect, useState } from 'react';

import { useUserUpdateAction } from '@rhino-project/core/queries';
import { NetworkParamError } from '@rhino-project/core/lib';
import { AuthForm, type AuthFormValues } from '../auth/AuthForm';
import { Alert, AlertContent, AlertTitle } from '@heroui/react';

export const ChangePassword = () => {
  const { t } = useTranslation();
  const [showAlert, setShowAlert] = useState(false);
  const {
    mutate: userUpdate,
    isPending,
    isSuccess,
    error
  } = useUserUpdateAction();
  const paramError = error as NetworkParamError | null;

  // eslint-disable-next-line @eslint-react/set-state-in-effect, react-hooks/set-state-in-effect
  useEffect(() => setShowAlert(isSuccess), [isSuccess]);

  const handleSubmit = (formValues: AuthFormValues) => userUpdate(formValues);

  return (
    <>
      <AuthForm
        currentPasswordField
        passwordField
        passwordConfirmField
        primaryAction={t('rhino.frontend.messages.change_password')}
        isPending={isPending}
        errors={paramError?.errors}
        onSubmit={handleSubmit}
      />

      {showAlert && (
        <Alert status="success">
          <AlertContent>
            <AlertTitle>
              {t(
                'rhino.frontend.messages.your_password_has_been_changed_successfully'
              )}
            </AlertTitle>
          </AlertContent>
        </Alert>
      )}
    </>
  );
};
